import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { NumberField, SelectField } from 'src/components/finalForm';
import { RATE_LIMIT_UNIT_OPTIONS } from 'src/utils/integrations';

type RateLimitFieldProps = {
  prefix: 'ip' | 'credentials' | 'verifier';
  title: string;
  description: string;
  disabled?: boolean;
};

export const RateLimitField: React.FC<RateLimitFieldProps> = ({
  prefix,
  title,
  description,
  disabled,
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700}>
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        {description}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Field
          name={`${prefix}LimitAttempts`}
          component={NumberField}
          label="Attempts"
          disabled={disabled}
          decimalScale={0}
          allowNegative={false}
          fullWidth
          placeholder="1"
          required
        />
        <Typography variant="body2" color="text.secondary" sx={{ pt: 2, whiteSpace: 'nowrap' }}>
          per
        </Typography>
        <Field
          name={`${prefix}LimitWindowValue`}
          component={NumberField}
          label="Window"
          disabled={disabled}
          decimalScale={0}
          allowNegative={false}
          fullWidth
          placeholder="1"
          required
        />
        <Field
          name={`${prefix}LimitWindowUnit`}
          component={SelectField}
          label="Unit"
          disabled={disabled}
          options={RATE_LIMIT_UNIT_OPTIONS}
          fullWidth
        />
      </Stack>
    </Box>
  );
};
